import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../lib/analytics';

/**
 * Custom hook to initialize Google Analytics and track page views
 * 
 * Usage: Add <useAnalytics /> to your App component
 */
export const useAnalytics = () => {
  const location = useLocation();
  // Use GA4 ID if set, otherwise fall back to Firebase Measurement ID
  // Note: Firebase Analytics uses GA4, so they share the same Measurement ID
  // Your Firebase Measurement ID is: G-79VVKCKV8P (set in env.development)
  const measurementId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 
                        process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

  useEffect(() => {
    // Initialize GA on mount
    if (measurementId && typeof window !== 'undefined') {
      initGA(measurementId);
    }
  }, [measurementId]);

  useEffect(() => {
    // Track page view on route change
    if (measurementId && typeof window !== 'undefined' && window.gtag) {
      trackPageView(location.pathname + location.search, document.title);
    }
  }, [location, measurementId]);
};

export default useAnalytics;

